import { put, takeEvery, call, type SagaReturnType } from 'redux-saga/effects'
import {
    FETCH_ALL_ZONES,
    GET_ZONE_PARKING_ASSISTANT_SETTINGS,
    UPDATE_ZONE_PARKING_ASSISTANT_SETTINGS,
} from 'src/redux/zone/zone.types'
import { setAllZones, setZoneParkingAssistantSettings, type GetZoneAction } from 'src/redux/zone'
import { getAllZones, getParkingAssistantSettingsPerZone, updateParkingAssistantSettingsPerZone } from 'src/api'
import { showNotification } from 'src/components/parts/notifications/notifications'

type GetAllZonesRes = SagaReturnType<typeof getAllZones>

export function* fetchAllZones() {
    const zones: GetAllZonesRes = yield call(getAllZones)

    if (zones instanceof Error) {
        yield call(showNotification, 'error', 'Failed to get zones')
    } else {
        yield put(setAllZones(zones))
    }
}

type GetParkingAssistantSettingsRes = SagaReturnType<typeof getParkingAssistantSettingsPerZone>

export function* getZoneParkingAssistantSettings(action: GetZoneAction<typeof GET_ZONE_PARKING_ASSISTANT_SETTINGS>) {
    const id = action.payload

    const result: GetParkingAssistantSettingsRes = yield call(getParkingAssistantSettingsPerZone, id)
    if (result instanceof Error) {
        yield call(showNotification, 'error', result.message)
        return
    }

    yield put(setZoneParkingAssistantSettings(result))
}

type UpdateParkingAssistantSettingsRes = SagaReturnType<typeof updateParkingAssistantSettingsPerZone>

export function* updateZoneParkingAssistantSettings(
    action: GetZoneAction<typeof UPDATE_ZONE_PARKING_ASSISTANT_SETTINGS>,
) {
    const settings = action.payload
    const result: UpdateParkingAssistantSettingsRes = yield call(updateParkingAssistantSettingsPerZone, settings)

    if (result instanceof Error) {
        yield call(showNotification, 'error', result.message)
        return
    }

    yield call(showNotification, 'success', 'Successfully updated the Parking Assistant Settings')
}

export default function* watcher() {
    yield takeEvery(FETCH_ALL_ZONES, fetchAllZones)
    yield takeEvery(GET_ZONE_PARKING_ASSISTANT_SETTINGS, getZoneParkingAssistantSettings)
    yield takeEvery(UPDATE_ZONE_PARKING_ASSISTANT_SETTINGS, updateZoneParkingAssistantSettings)
}
